import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  COMPENSATE_REQUEST_GET_REQUEST,
  COMPENSATE_REQUEST_GET_SUCCESS,
  COMPENSATE_REQUEST_GET_FAILURE,
  COMPENSATE_REQUEST_GET_RESET,
  COMPENSATE_REQUEST_CREATE_REQUEST,
  COMPENSATE_REQUEST_CREATE_SUCCESS,
  COMPENSATE_REQUEST_CREATE_FAILURE,
  COMPENSATE_REQUEST_CREATE_RESET,
  COMPENSATE_REQUEST_APPROVE_REQUEST,
  COMPENSATE_REQUEST_APPROVE_SUCCESS,
  COMPENSATE_REQUEST_APPROVE_FAILURE,
  COMPENSATE_REQUEST_APPROVE_RESET,
  COMPENSATE_REQUEST_PREVIEW_REQUEST,
  COMPENSATE_REQUEST_PREVIEW_SUCCESS,
  COMPENSATE_REQUEST_PREVIEW_FAILURE,
  COMPENSATE_REQUEST_PREVIEW_RESET,
  COMPENSATE_REQUEST_CANCEL_REQUEST,
  COMPENSATE_REQUEST_CANCEL_SUCCESS,
  COMPENSATE_REQUEST_CANCEL_FAILURE,
  COMPENSATE_REQUEST_CANCEL_RESET,
} from '../../constants'

export function createCompensateRequest(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates?commit=true`,
      method: 'POST',
      types: [
        COMPENSATE_REQUEST_CREATE_REQUEST,
        COMPENSATE_REQUEST_CREATE_SUCCESS,
        COMPENSATE_REQUEST_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function previewCompensateRequest(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates?commit=false`,
      method: 'POST',
      types: [
        COMPENSATE_REQUEST_PREVIEW_REQUEST,
        COMPENSATE_REQUEST_PREVIEW_SUCCESS,
        COMPENSATE_REQUEST_PREVIEW_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getCompensateRequest(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates`,
      method: 'GET',
      types: [
        COMPENSATE_REQUEST_GET_REQUEST,
        COMPENSATE_REQUEST_GET_SUCCESS,
        COMPENSATE_REQUEST_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function approveCompensateRequest(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates/approve/${id}`,
      method: 'POST',
      types: [
        COMPENSATE_REQUEST_APPROVE_REQUEST,
        COMPENSATE_REQUEST_APPROVE_SUCCESS,
        COMPENSATE_REQUEST_APPROVE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function cancelCompensateRequest(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/compensates/cancel/${id}`,
      method: 'POST',
      types: [
        COMPENSATE_REQUEST_CANCEL_REQUEST,
        COMPENSATE_REQUEST_CANCEL_SUCCESS,
        COMPENSATE_REQUEST_CANCEL_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function resetGetCompensateRequest() {
  return {
    type: COMPENSATE_REQUEST_GET_RESET,
  }
}
export function resetCreateCompensateRequest() {
  return {
    type: COMPENSATE_REQUEST_CREATE_RESET,
  }
}
export function resetApproveCompensateRequest() {
  return {
    type: COMPENSATE_REQUEST_APPROVE_RESET,
  }
}
export function resetPreviewCompensateRequest() {
  return {
    type: COMPENSATE_REQUEST_PREVIEW_RESET,
  }
}
export function resetCancelCompensateRequest() {
  return {
    type: COMPENSATE_REQUEST_CANCEL_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/compensate-request/compensate-request-action.js